import CommonError from '@/errors/common-error'
import axios from 'axios'
import _ from 'lodash'
import uuid from 'uuid/v4'

class QuoteService {
  constructor () {
    this.instance = axios.create({
      baseURL: '/api',
      timeout: 10000
    })
  }

  async uploadFile ({ file, filename, quoteId }, onProgress) {
    const data = new FormData()

    data.append('quoteId', quoteId)
    data.append('filename', filename)
    data.append('file', file, file.name)

    let response

    try {
      response = await this.instance.post('/file', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `bearer ${localStorage.getItem('access_token')}`,
          'Id-Token': localStorage.getItem('id_token')
        },
        onUploadProgress (progressEvent) { onProgress(progressEvent) },
        timeout: 3600000
      })
    } catch (error) {
      throw new CommonError({
        title: 'Error',
        message: _.get(error, 'response.data.error.message', error.message)
      })
    }

    return response
  }

  async fetchProfile () {
    let response

    try {
      response = await this.instance.get('/user-profile', {
        headers: {
          Authorization: `bearer ${localStorage.getItem('access_token')}`,
          'Id-Token': localStorage.getItem('id_token')
        }
      })
    } catch (error) {
      throw new CommonError({
        title: 'Error',
        message: _.get(error, 'response.data.error.message', error.message)
      })
    }

    console.log(response.data.content)

    response.data.content.zipCode = response.data.content.zip_code

    return response
  }

  async completeProfile ({ firstname, lastname, title, company, phone, fax, address, city, zipCode, country, province }) {
    let response

    try {
      response = await this.instance.post('/complete-profile', {
        firstname,
        lastname,
        title,
        company,
        phone,
        fax,
        address,
        city,
        zipCode,
        country,
        province
      }, {
        headers: {
          Authorization: `bearer ${localStorage.getItem('access_token')}`,
          'Id-Token': localStorage.getItem('id_token')
        }
      })
    } catch (error) {
      throw new CommonError({
        title: 'Error',
        message: _.get(error, 'response.data.error.message', error.message)
      })
    }
    return response
  }

  async sendQuote (args) {
    let response

    try {
      response = await this.instance.post('/quote', {
        language: window.i18n.locale,
        ...args
      }, {
        headers: {
          Authorization: `bearer ${localStorage.getItem('access_token')}`,
          'Id-Token': localStorage.getItem('id_token')
        }
      })
    } catch (error) {
      throw new CommonError({
        title: 'Error',
        message: _.get(error, 'response.data.error.message', error.message)
      })
    }

    return response
  }

  async createUser (args) {
    let response

    try {
      response = this.instance.post('/user', args)
    } catch (error) {
      throw new CommonError({
        title: 'Error',
        message: _.get(error, 'response.data.error.message', error.message)
      })
    }

    return response
  }

  async oldLogin (args) {
    let response

    try {
      response = await this.instance.post('/old-login', args)
    } catch (error) {
      throw new CommonError({
        title: 'Error',
        message: _.get(error, 'response.data.error.message', error.message)
      })
    }

    if (_.get(response, 'data.user.username').indexOf('@') > -1) {
      response.data.user.username = uuid().substring(0, 14)
    }

    return response
  }
}

export default new QuoteService()
